var map = {
	"./Base/serverStyle": 125,
	"./Clutch/serverStyle": 1876,
	"./NewUi/serverStyle": 1877,
	"./OldUi/serverStyle": 1878,
	"./SpireonNew/serverStyle": 1879,
	"./SpireonOld/serverStyle": 1880
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;